import * as React from 'react';
import dayjs from 'dayjs';
import { Page, Grid, Card, Table, Button, Alert, Text } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import Request from '../../shared/request';
import './order.scss';

// const paidTypeNames = {
//   PROMOTION: '赠送',
//   YOUZAN: '支付',
//   WECHAT: '支付',
//   ALIPAY: '支付',
//   PAYPAL: '支付',
//   CARD: '充值卡',
//   REPAIR: '调整',
//   ADMIN: '手动调整',
//   BUY: '后台购买',
// };

class BindIndex extends PageComponent {
  state = {
    orderCount: null,
    orderList: [],
  };

  async componentDidMount() {
    const resOrders = await Request.call('getOrders');
    if (resOrders) {
      this.setState({
        orderCount: resOrders.count,
        orderList: resOrders.list,
      });
    }
  }

  getOrderTable() {
    const { orderList, orderCount } = this.state;

    if (orderCount === null) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <Text align="center">Loading...</Text>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    let orderListItems = [];
    if (orderList) {
      orderListItems = orderList.map((item, i) => {
        if (item.vasInfo) {
          const { category, bandwidth, number } = item.vasInfo;
          return {
            key: i,
            item: [
              {
                content: dayjs(item.createdAt || item.paidAt).format(
                  'YYYY-MM-DD HH:mm',
                ),
              },
              {
                content: `增值服务 ${
                  category === 'device' ? '-扩充设备' : '-扩充带宽'
                }`,
              },
              {
                content: `${bandwidth ? `${bandwidth}Mb` : `${number}个`}`,
              },
            ],
          };
        }
        return {
          key: i,
          item: [
            {
              content: dayjs(item.createdAt || item.paidAt).format(
                'YYYY-MM-DD HH:mm',
              ),
            },
            {
              content: item.planId !== 'GAME' ? '普通会员' : '高级会员',
            },
            {
              content: item.planDays ? `${item.planDays}天` : '-',
            },
          ],
        };
      });
    }

    return orderCount ? (
      <Table
        responsive
        className="card-table table-vcenter text-nowrap order-tables"
        headerItems={[
          { content: '购买时间' },
          { content: '订单类型' },
          { content: '订单数量' },
        ]}
        bodyItems={orderListItems}
      />
    ) : (
      <Alert type="primary" hasExtraSpace className="home-alert vip-alert">
        <div>升级VIP可以加速音视频、不限带宽不限流量、免广告</div>
        <div>
          <Button
            outline
            size="md"
            color="success"
            RootComponent="a"
            href="/buy?utm_source=dashboard&utm_medium=order"
            target="noopener noreferrer">
            立即升级
          </Button>
        </div>
      </Alert>
    );
  }

  render() {
    return (
      <Page.Content className="page-order">
        <Card>
          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>返回首页</span>
            </Link>
            <Card.Title>当前订单{this.state.orderCount}</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="body">{this.getOrderTable()}</div>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default BindIndex;
